import { ReactSVG } from "react-svg";

export const Image = ({ src, color = "#fff", height, width }) => {
    return (
        <ReactSVG
            src={src}
            $filled={true}
            beforeInjection={(svg) => {
                svg.setAttribute("style", `height: ${height}px; width: ${width}px;`);
                ["path", "g", "rect", "circle", "polygon", "ellipse"].forEach((tag) => {
                    svg.querySelectorAll(tag).forEach((el) => {
                      el.setAttribute("style", `fill: ${color} !important`);
                    });
                  });
            }}
            fill={color ?? "#fff"}
            height={height ?? 25}
            width={width ?? 25}
        />
    )
}